import { render } from "./PhoneNumberInput.vue?vue&type=template&id=14e98c21&scoped=true"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js"

import "./PhoneNumberInput.vue?vue&type=style&index=0&id=14e98c21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e98c21"]])

export default __exports__